export enum ContestType {
	Tourney,
	League
}
